import { ComponentProps } from 'react'

import { system } from '../../../system'

export type FlexProps = ComponentProps<typeof system.div>

export const Flex = system('div')({
  display: 'flex'
})
